import React, { Component } from "react";
import PropTypes from "prop-types";
import "../theme/appStoreLink.css";

class AppStoreLink extends Component {
  static propTypes = {
    appleOnly: PropTypes.bool,
    googleOnly: PropTypes.bool
  };
  static defaultProps = {
    appleOnly: false,
    googleOnly: false
  };

  appleLink = () => {
    return (
      <a
        href="https://apps.apple.com/app/id1480267775"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          alt="Apple App Store"
          className="appstore_badge"
          src={require("../images/home/apple_app_store.png")}
        />
      </a>
    );
  };
  googleLink = () => {
    return (
      <a
        href="https://play.google.com/store/apps/details?id=com.seahawktech.mucky"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          alt="Google Play App Store"
          className="appstore_badge"
          src={require("../images/home/google_app_store.png")}
        />
      </a>
    );
  };

  render() {
    const { appleOnly, googleOnly } = this.props;
    const showBoth = !appleOnly && !googleOnly;

    if (showBoth) {
      return (
        <div className="appstore_badge_container">
          {this.appleLink()}
          {this.googleLink()}
        </div>
      );
    } else {
      if (appleOnly) {
        return this.appleLink();
      } else {
        return this.googleLink();
      }
    }
  }
}

export default AppStoreLink;



// WEBPACK FOOTER //
// ./src/components/AppStoreLink.js